'use client';

import Error from '@/components/core/error';

export default function GlobalError() {
  return <Error />;
}
